module.exports = __webpack_public_path__ + "static/media/add.e4549f9f.svg";